/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/*
 *
 * Action types for ACESWaitlist.
 *
 */

import { ReduxUtils } from '@spm/core';

const POST_ACES_CHAP_WAITLIST_ENROLL = ReduxUtils.generatePostActionTypes(
  'ua-library',
  `ACESWAITLIST/POST_ACES_CHAP_WAITLIST_ENROLL`
);

const FETCH_ACES_CHAP_WAITLIST_APPLIED = ReduxUtils.generateFetchActionTypes(
  'ua-library',
  `ACESWAITLIST/FETCH_ACES_CHAP_WAITLIST_APPLIED`
);

const FETCH_ACES_CHAP_WAITLIST_FUND_AVAILABLE = ReduxUtils.generateFetchActionTypes(
  'ua-library',
  `ACESWAITLIST/FETCH_ACES_CHAP_WAITLIST_FUND_AVAILABLE`
);

const POST_ACES_CHAP_WAITLIST_SUBMIT_FORM = ReduxUtils.generatePostActionTypes(
  'ua-library',
  `ACESWAITLIST/POST_ACES_CHAP_WAITLIST_SUBMIT_FORM`
);

export {
  POST_ACES_CHAP_WAITLIST_ENROLL,
  FETCH_ACES_CHAP_WAITLIST_APPLIED,
  FETCH_ACES_CHAP_WAITLIST_FUND_AVAILABLE,
  POST_ACES_CHAP_WAITLIST_SUBMIT_FORM,
};
